module.exports = __webpack_public_path__ + "static/img/icon2.aadeabe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/icon2.png
// module id = Tm0D
// module chunks = 44